package com.neurobs.ccabserver.translation.components.phrasetranslation.components

import com.neurobs.ccab.db.TranslationData
import com.neurobs.react.semanticui.{UiButtonFactory, UiHeaderFactory, UiLoaderFactory}
import com.neurobs.react.{ReactUtil, StyleUtil}
import com.neurobs.ccabserver.translation.states.{EngineTranslationStateGenerator, PhraseTranslationStateGenerator}
import com.neurobs.react.ReactElementFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object EngineTranslation {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val engineTranslationState = EngineTranslationStateGenerator.accessState

    def awaitingServerTranslation = engineTranslationState.awaitingServerTranslation
    def engineTranslation = engineTranslationState.translation

    def engineTranslationText = engineTranslation match {
      case Left(errorOpt) => errorOpt match {
        case None => "This shouldn't appear"
        case Some(error) => error
      }
      case Right(translation) => translation.text
    }

    def pStyling = Seq[(String, js.Any)](("fontSize", "14px"))

    props.enclosingElement(
      if (awaitingServerTranslation) Seq(UiLoaderFactory.ActiveTextLoader("Loading translation...")("small"))
      else {
        Seq[ReactElement](
          UiHeaderFactory.TextHeader(engineTranslationState.translationEngine.displayName, 2)(("", "white-text")),
          ReactElementFactory.P(engineTranslationText)(pStyling),
          EnginePromotionButton()
        )
      }
    )
  }
}

@react
object EnginePromotionButton {

  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val phraseTranslationState = PhraseTranslationStateGenerator.accessState
    val engineTranslationState = EngineTranslationStateGenerator.accessState

    def existingTranslation = engineTranslationState.phraseTranslationCache.existingTranslation

    def promoteTranslation(existingTranslation: TranslationData) =  phraseTranslationState.updateUserTranslationText(existingTranslation.text)

    existingTranslation match {
      case None => null
      case Some(existingTranslation) =>
        UiButtonFactory.Button(
          "Use translation",
          handleClick = () => promoteTranslation(existingTranslation)
        )("inverted")
    }
  }
}